import { render, staticRenderFns } from "./RacingSupports.vue?vue&type=template&id=a07117b6"
import script from "./RacingSupports.vue?vue&type=script&lang=ts"
export * from "./RacingSupports.vue?vue&type=script&lang=ts"
import style0 from "./RacingSupports.vue?vue&type=style&index=0&id=a07117b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports